import { Component } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter, map, of } from 'rxjs';

import { isSearchPath } from '../../../search/search.utils';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent {

  route$ = of({
    isLogin: false,
    isSearch: false,
  });

  constructor(
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.route$ = this.router.events.pipe(
      filter(event => event instanceof NavigationStart),
      map((event: NavigationStart) => {
        return {
          isLogin: event.url === '/login',
          isSearch: isSearchPath(event.url),
        };
      }),
    );
  }
}
